import request from './axios'



export const loginUserInfo_api = (parma) => {
  return request({
    url: '/api/User/LoginUser',
    method: 'post',
  });

}



// 获取会议日程数据
export const getMeetingData_api = (parma) => {
  return request({
    url: '/api/meeting/GetMeetingList?gid=' + parma['gid'],
    method: 'get',
  });

}

//发送预约会议数据
export const sendUserOrder_api = (parmas) => {
  return request({
    url: '/api/MeetingAppointment/SaveMeetingAppointmentAndSendEmailToUser',
    method: 'post',
    data: parmas
  });

}

//兑奖并发送邮件
export const exchangeAndSendEmail_api= (status) => {
  return request({
    url: '/api/user/SendEmail',
    method: 'post',
    data: {
      status
    }
  });
}

//发送统计代码 用户PV 信息
// {"PageName":"home","UserEmail":"test@gsail.net","Gid":"100000000000000","TC":"渠道"}
export const sendPvAction_api = (parmas) => {
 return new Promise((reslove) => {
   reslove
 });

  return request({
    url: '/api/PageView/PV',
    method: 'post',
    data: parmas
  });

}

//发送统计代码 用户UV 信息
//{"TrackName":"menu-home","TrackTextName":"导航栏<首页>","TrackDisplayName":"这里是详细描述","TrackTextContent":"会议标题<会议时间>","PageName":"home","UserEmail":"test@test.com","Gid":"100000000000000","TC":"渠道"}
export const sendUvAction_api = (parmas) => {

  return new Promise((reslove) => { reslove });

  return request({
    url: '/api/PageView/BehaviorRecord',
    method: 'post',
    data: parmas
  });

}

// 获取通告消息统计

export const getNotifyMsg = (parmas) => {
  return request({
    url: 'api/message/getsignalrmessage',
    method: 'get'
  });

}


// 获取用户预约的会议列表

export const getUserOrder_api = (parmas) => {
  return request({
    url: 'api/meeting/getuserappointmentlist',
    method: 'get'
  });

}

/**
 * @description: 获取英特尔解决方案视频
 */
export const getVideo_api = () => {
  return request({
    url: '/api/video/getVideoList',
    method: 'get'
  })
}


/**
 * @description: 获取下载专区资料
 */
export const getDownloadList_api = () => {
  return request({
    url: '/api/partner/getDownloadList',
    method: 'post'
  })
}

/**
 * @description:下载专区下载文件
 * @param {Object} params { gid: '', email: '', id: '', isZip: '' }
 */
export const downloadFile_api = (params) => {
  return request({
    url: '/api/partner/DownloadFile',
    method: 'post',
    data: params
  })
}

/**
 * @description: 提交调查问卷
 * @param {Object} dynamicParams
 */
export const submitQuestion_api = (dynamicParams) => {
  return request({
    url: '/api/question/SubmitQuestion',
    method: 'post',
    data: dynamicParams
  })
}

/**
 * @description: 获取提问列表
 * @param {Object} params { messageType: 2 提问, page: 1 当前页数, limit: 5 每页条数 }
 */
export const getCommentList_api = (params) => {
  return request({
    url: '/api/comment/GetCommentList',
    method: 'post',
    data: params
  })
}

/**
 * @description: 提交提问
 * @param {Object} params { content: '', messageType: 2, tag: '', topicType: 1/2 }
 */
export const commentSubmit_api = (params) => {
  return request({
    url: '/api/comment/CommentSubmit',
    method: 'post',
    data: params
  })
}

/**
 * @description: 点赞
 * @param {Object} params { gid: '', userEmail: '', type: 2, publicId: '', desc: '' }
 */
export const giveALike_api = (params) => {
  return request({
    url: '/api/star/GiveALike',
    method: 'post',
    data: params
  })
}

/**
 * @description: 获取话题列表
 */
export const getTopicList_api = () => {
  return request({
    url: '/api/comment/GetTopicList',
    method: 'get'
  })
}

/**
 * @description: 获取 5 期福来开奖列表
 */
export const getLuckyCodeList = () => {
  return request({
    url: '/api/luckycode/GetLuckyCodeHistoryList',
    method: 'post'
  })
}

/**
 * 福来号码
 */

export const getRandomLuckyCode_api = (parmas) => {

  return request({
    url: 'api/LuckyCode/GetUserLuckyCode?gid=' + parmas,
    method: 'get'
  })

}

export const getbannerlist_api = (parmas) => {

  return request({
    url: "/api/meeting/getbannerlist",
    method: 'post'
  })

}



